import React, {useState} from 'react';
import {PinInput, PinInputField} from '@chakra-ui/pin-input';

export default function ModalPin(props) {
  const [value, setValue] = useState('');
  const handleChange = (value) => {
    setValue(value);
    props.onChange(value);
  };

  //   const handleComplete = (value) => {
  //     console.log(value);
  //   };

  const inputStyles = {
    textAlign: "center",
    margin: '0 2px',
    padding: '12px 0.5ch',
    fontSize: '2rem',
    width: '3ch'
  };

  return (
    <PinInput
      value={value}
      onChange={handleChange}
      // onComplete={handleComplete}
    >
      <PinInputField style={inputStyles} />
      <PinInputField style={inputStyles} />
      <PinInputField style={inputStyles} />
      <PinInputField style={inputStyles} />
    </PinInput>
  );
}
